import React, { createContext, useContext, useMemo, useState } from 'react';
import useToggle from '../../hooks/useToggle';
import { GoogleMapsContextI } from './types';

const GoogleMapsContext = createContext<GoogleMapsContextI | null>(null);

export const GoogleMapsProvider = ({ children }) => {
  const [isInitializedMap, setIsInitializedMap] = useState(false);
  const [isOpenModal, toggleModal] = useToggle(false);
  const [mapData, setMapData] = useState({
    initialLocation: undefined,
    coordinates: undefined,
    isOpen: false,
    pinSelected: false,
    isMarkerDraggable: true
  });

  const [mapModalData, setMapModalData] = useState({
    modalId: 'map-modal',
    onClose: null,
    saveCoordinates: null
  });

  const value = useMemo(
    () => ({
      isOpenModal,
      toggleModal,
      mapData,
      setMapData,
      isInitializedMap,
      setIsInitializedMap,
      mapModalData,
      setMapModalData
    }),
    [
      mapData,
      setMapData,
      isInitializedMap,
      setIsInitializedMap,
      isOpenModal,
      toggleModal,
      mapModalData,
      setMapModalData
    ]
  );

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (context === undefined) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};
